const featuresPay = {
    featureTitle: '基於數據做出商業決策',
    featureDescription:
        '了解哪些商品暢銷並帶來最高利潤，隨時隨地存取財務報表。讓您的生意盡在掌握！',
    featureButton: "高級訂閱",
    featureStartingPrice: '80',
    featureEndingPart: '30',
    featureStaringText: '起價',
    featureEndingText: '千元',

    features: [
        {
            title: '無限商品',
            description: '新增您擁有的所有商品，沒有任何限制。'
        },
        {
            title: '無限員工',
            description: '將員工／管理員無限制地加入企業中。'
        },
        {
            title: '無限歷史紀錄',
            description: '無限制查看舊庫存紀錄的變更。'
        },
        {
            title: '歷史篩選',
            description: '按類型、類別、員工與日期輕鬆查看歷史紀錄。'
        },
        {
            title: '匯出到 Excel',
            description: '一鍵將庫存紀錄歷史匯出到 Microsoft Excel。'
        },
        {
            title: '匯出到 PDF',
            description: '一鍵將最新的商品與庫存清單匯出為 PDF。'
        }
    ],
    warehousesGuide: [
        {
            desc: '建立多個倉庫以更好地管理庫存。'
        },
        {
            desc: '將產品分配到特定位置。'
        },
        {
            desc: '監控各倉庫的庫存水準。'
        }
    ],
    addVariantsGuide: [
        { desc: '新增尺寸、顏色或材質的變體。' },
        { desc: '為每個變體設定庫存水準。' },
        { desc: '跨倉庫追蹤庫存。' }
    ]
}
export default featuresPay;